import React, { useState, useEffect, useCallback } from 'react';
import {
    Container, Row, Col, Breadcrumb,
} from "react-bootstrap";
import { NavLink, useNavigate } from "react-router-dom";
import Base from '../Base';
import DatePicker from 'react-datepicker';
import PaginationComponent from '../common/Pagination';
import { getActivityList } from './activityHelper'
import { truncateText } from '../../utils';
import { FaArrowLeft } from 'react-icons/fa';

const ActivityLog = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const [perPage] = useState(25);
    const [selectedMonth, setSelectedMonth] = useState(new Date());
    const [logs, setLogs] = useState([]);
    const [totalCount, setTotalCount] = useState(0);
    const [loading, setLoading] = useState(false);
    const itemsPerPage = 5;
    const navigate = useNavigate();
    const handlePagination = (page) => {
        setCurrentPage(page);
    };

    const fetchLogs = useCallback(async () => {
        const year = selectedMonth.getFullYear();
        const month = selectedMonth.getMonth() + 1;
        const startDate = `${year}-${month.toString().padStart(2, '0')}-01`;

        // const payload = {
        //     page: currentPage,
        //     perpage: perPage,
        //     start_date: startDate,
        // };

        setLoading(true);

        try {
            const response = await getActivityList(currentPage, perPage, startDate);
            if (response.type === "success") {
                const logsFromApi = response.data.list.map(item => ({
                    id: item.id,
                    user: item.user?.name || 'Unknown',
                    email: item.user?.email || 'No Email',
                    action: item.content?.content || 'No Action',
                    title: item.content?.title || 'No Action',
                    path: '',
                    timestamp: new Date(item.created_time),
                }));

                setLogs(logsFromApi);
                setTotalCount(response.data.total_count);
            } else {
                setLogs([]);
                setTotalCount(0);
            }
        } catch (error) {
            console.error("Error fetching activity logs:", error);
            setLogs([]);
            setTotalCount(0);
        }

        setLoading(false);
    }, [currentPage, selectedMonth, itemsPerPage]);

    useEffect(() => {
        fetchLogs();
    }, [fetchLogs]);

    const handleMonthSelect = (date) => {
        setSelectedMonth(date);
        setCurrentPage(1);
    };

    const totalPages = Math.ceil(totalCount / itemsPerPage);

    const formatTimestamp = (timestamp) => {
        const options = { month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric', hour12: true };
        return timestamp.toLocaleString('en-US', options);
    };

    const handleBackToHome = () => {
        navigate(-1);
    };

    return (
        <Base>
            <Container fluid >
                <Row>
                    <Col sm={12}>
                        <div className="flex flex-col font-sans">
                            {/* Header Section */}
                            <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center bg-white rounded-lg gap-4 mb-4">
                                <div className="d-flex flex-column align-items-start">
                                    <button
                                        variant="link"
                                        className="text-primary d-flex align-items-center gap-2 p-0 mb-2 transition-transform duration-200 hover:scale-105"
                                        onClick={handleBackToHome}
                                        style={{ fontSize: "16px", textDecoration: "none", background: "none", border: "none" }}

                                    >
                                        <FaArrowLeft size={14} /> Back
                                    </button>

                                    <h1 className="m-0 text-[28px] font-bold text-gray-800">Activity Log</h1>
                                </div>

                                {/* DatePicker */}
                                <div className="relative overflow-visible">
                                    <DatePicker
                                        selected={selectedMonth}
                                        onChange={handleMonthSelect}
                                        dateFormat="MMMM yyyy"
                                        showMonthYearPicker
                                        popperPlacement="bottom-end"
                                        calendarClassName="z-50 bg-white rounded-lg shadow-md border mt-2"
                                        // wrapperClassName="!z-50 relative"
                                        customInput={
                                            <button className="flex items-center justify-center text-gray-700 font-semibold text-sm bg-white border border-gray-300 rounded-full px-4 py-2 shadow-sm hover:bg-gray-100 transition w-full sm:w-auto">
                                                <span className="mr-2">
                                                    {selectedMonth.toLocaleString('en-US', { month: 'long', year: 'numeric' })}
                                                </span>
                                                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10m-10 4h6" />
                                                </svg>
                                            </button>
                                        }
                                    />
                                </div>
                            </div>

                            {/* Activity List */}
                            <div className="bg-white rounded-lg overflow-hidden relative">
                                <div className="max-h-[400px] sm:max-h-[800px] lg:max-h-[700px] overflow-y-auto">
                                    {loading ? (
                                        <div className="p-5 text-center text-gray-500 text-lg">
                                            Loading activity logs...
                                        </div>
                                    ) : logs.length > 0 ? (
                                        logs.map((log) => (
                                            <div key={log.id} className="flex flex-col sm:flex-row sm:items-start py-3 px-3 sm:px-5 border-b border-gray-200 last:border-b-0 gap-3 sm:gap-0">
                                                {/* User Info Section */}
                                                <div className="flex items-start sm:w-1/4 flex-shrink-0">
                                                    <div className="bg-blue-600 text-white rounded-full w-8 h-8 sm:w-10 sm:h-10 flex justify-center items-center font-bold text-sm sm:text-lg mr-3 flex-shrink-0">
                                                        {log.user.charAt(0)}
                                                    </div>
                                                    <div className="flex flex-col min-w-0 flex-1">
                                                        <div className="font-bold text-gray-800 text-sm text-left break-words">
                                                            {window.innerWidth < 640 ? truncateText(log.user, 15) : truncateText(log.user, 20)}
                                                        </div>
                                                        <div className="text-gray-600 text-xs text-left break-all">
                                                            {window.innerWidth < 640 ? truncateText(log.email, 15) : truncateText(log.email, 20)}
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* Action Section */}
                                                <div className="flex-1 sm:w-2/4 flex flex-col justify-center text-left sm:px-2">
                                                    {log.title && <div className="text-gray-500 text-sm mb-1">{log.title}</div>}
                                                    <div className="text-gray-700 text-sm sm:text-base mb-1 break-words">
                                                        {window.innerWidth < 640 ? truncateText(log.action, 25) :
                                                            window.innerWidth < 1024 ? truncateText(log.action, 35) :
                                                                truncateText(log.action, 40)}
                                                    </div>
                                                </div>

                                                {/* Timestamp Section */}
                                                <div className="sm:w-1/4 text-gray-600 text-xs sm:text-sm whitespace-nowrap text-left sm:text-right self-start sm:self-center">
                                                    {formatTimestamp(log.timestamp)}
                                                </div>
                                            </div>
                                        ))
                                    ) : (
                                        <div className="p-8 sm:p-16 lg:p-32 text-center text-gray-500 text-base sm:text-lg">
                                            No activity logs available for this month.
                                        </div>
                                    )}
                                </div>
                            </div>

                            {/* Pagination */}
                            {totalCount > perPage && (
                                <Row className="m-2">
                                    <Col md={12} className="d-flex justify-content-center">
                                        <PaginationComponent
                                            total_count={totalCount}
                                            current_page={currentPage}
                                            handleOnClick={handlePagination}
                                            per_page={perPage}
                                        />
                                    </Col>
                                </Row>
                            )}
                        </div>
                    </Col>
                </Row>
            </Container>
        </Base>
    );
};

export default ActivityLog;